export const SET_THEME = "UI/SET_THEME";
export const SET_SIDEBAR_EXPANDED = "UI/SET_SIDEBAR_EXPANDED";
